import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { trackFixedRateNavViewed } from '../trackers/fixed-rate';

// Module-level guard (not a per-mount ref): the Fixed Rate tab renders from
// several nav surfaces simultaneously (NavBar, MenuDropdown), so the impression
// is deduped to once per page-load session rather than firing once per mount.
let hasTrackedThisSession = false;

/** Fires the Fixed Rate nav-tab impression once per session. */
export const useTrackFixedRateNavViewed = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
};
function _temp() {
  if (hasTrackedThisSession) {
    return;
  }
  hasTrackedThisSession = true;
  trackFixedRateNavViewed();
}